var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSites = function SvgSites(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.203.999L7.25.998h.046a.728.728 0 01.067.008l.016.004c.086.013.17.044.252.092l.051.033 5.07 3.566 5.068-3.562a.75.75 0 011.174.509l.007.104v10.633a.75.75 0 01-.238.548l-.08.065-5.5 3.867a.744.744 0 01-.828.023L7.25 13.297 2.18 16.86a.75.75 0 01-1.174-.509l-.007-.104V5.615a.75.75 0 01.238-.548l.08-.065 5.5-3.867a.762.762 0 01.2-.1l.122-.029L7.203 1zm10.298 2.197l-4 2.812v8.8l4-2.813V3.196zM6.5 3.193l-4 2.812v8.799l4-2.812v-8.8zm1.502 0v8.799l4 2.812v-8.8l-4-2.811z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSites, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sites.5db542d3.svg";
export { ForwardRef as ReactComponent };